<button type="button" (click)="notifyOfCommentClicked()" class="btn btn-secondary" [disabled]="isDisabled()">
    <i class="fas fa-comments"></i> Notify of Comment
</button>
